import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { QUERY_KEYS } from 'constants/common';
import { type WellbeingTypes } from 'constants/wellbeing';
import { WellbeingService } from 'services/wellbeing';
import { type Wellbeing, type Tag } from 'types/wellbeing';
import { createTagMap } from 'utils/wellbeing';

export const useWellbeingContent = (type: WellbeingTypes): UseQueryResult<Wellbeing[]> =>
  useQuery<AxiosResponse<Wellbeing[]>, Error, Wellbeing[]>({
    queryKey: [QUERY_KEYS.FETCH_WELLBEING_CONTENT, type],
    queryFn: () => WellbeingService.getContent(type),
    select: response =>
      response?.data.map(item => ({
        ...item,
        type,
      })),
    staleTime: 1000 * 60 * 60, // 1 hour
    enabled: !!type,
  });

const useWellbeingTags = (): UseQueryResult<Tag[]> =>
  useQuery<AxiosResponse<Tag[]>, Error, Tag[]>({
    queryKey: [QUERY_KEYS.FETCH_WELLBEING_TAGS],
    queryFn: () => WellbeingService.getTags(),
    select: response => response?.data,
    refetchOnMount: false,
  });

export const useTagMap = (): Map<string, Tag> => {
  const { data: tagsData } = useWellbeingTags();
  return createTagMap(tagsData ?? []);
};
